import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CalendlySettings } from '../../../../SideBar/SettingsModal/CalendlySettings';
import { SETTING_ICONS } from '../../../constants';
import './CalendlySection.scss';

const CalendlySection: FC = () => {
  const Icon = SETTING_ICONS.calendly;
  const { t } = useTranslation();

  return (
    <div className="calendly-section calendly-section--new-tabs">
      <div className="calendly-section__block">
        <Stack gap={1} direction="row" alignItems="center">
          <Icon className="calendly-section__section-icon" />
          <Typography variant="body1" className="calendly-section__section-title">
            {t('settings.nav.calendly')}
          </Typography>
        </Stack>
        <CalendlySettings />
      </div>
    </div>
  );
};

export default CalendlySection;
